<template>
  <div class="app-container">
    <CoreNav v-if="isAuthenticated" />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CoreNav from "./components/CoreNav";

export default {
  name: "App",
  created() {
    console.log("Greetings. Get wild!");
  },
  components: {
    CoreNav,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      isAuthenticated: (state) => state.auth.authenticationStatus,
    }),
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inconsolata:wght@700&display=swap");

* {
  box-sizing: border-box;
}

@font-face {
  font-family: "F37 Ginger Regular";
  src: url("../public/fonts/F37-Ginger-Regular.ttf") format("truetype");
  font-weight: 200 800;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "F37Ginger";
  src: url("../public/fonts/F37Ginger.ttf") format("truetype");
  font-weight: 200 700 800;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Variable";
  src: url("../public/fonts/GeneralSans-Variable.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Variable.woff") format("woff"),
    url("../public/fonts/GeneralSans-Variable.ttf") format("truetype");
  font-weight: 200 700;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Extralight";
  src: url("../public/fonts/GeneralSans-Extralight.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Extralight.woff") format("woff"),
    url("../public/fonts/GeneralSans-Extralight.ttf") format("truetype");
  font-weight: 200;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Light";
  src: url("../public/fonts/GeneralSans-Light.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Light.woff") format("woff"),
    url("../public/fonts/GeneralSans-Light.ttf") format("truetype");
  font-weight: 300;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Regular";
  src: url("../public/fonts/GeneralSans-Regular.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Regular.woff") format("woff"),
    url("../public/fonts/GeneralSans-Regular.ttf") format("truetype");
  font-weight: 400;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Medium";
  src: url("../public/fonts/GeneralSans-Medium.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Medium.woff") format("woff"),
    url("../public/fonts/GeneralSans-Medium.ttf") format("truetype");
  font-weight: 500;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Semibold";
  src: url("../public/fonts/GeneralSans-Semibold.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Semibold.woff") format("woff"),
    url("../public/fonts/GeneralSans-Semibold.ttf") format("truetype");
  font-weight: 600;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Bold";
  src: url("../public/fonts/GeneralSans-Bold.woff2") format("woff2"),
    url("../public/fonts/GeneralSans-Bold.woff") format("woff"),
    url("../public/fonts/GeneralSans-Bold.ttf") format("truetype");
  font-weight: 700;
  font-display: swap;
  font-style: normal;
}

#app {
  font-family: "Nunito", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  font-family: "Inconsolata", monospace;
}

html,
body {
  height: 100%;
  overflow: hidden;
  font-family: "Nunito", "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-family: "Inconsolata", monospace;
}

button, input {
  font-family: "Inconsolata", monospace;
}

a {
  color: darkblue;
}

a:hover {
  color: blue;
}

body {
  overscroll-behavior-y: none;
  overscroll-behavior-x: none;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: scroll;
}

.landing-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 30px);
  border: 1px solid #eee;
  margin: 15px;
  border-radius: 3px;
  background-color: #fbfbfb;
  background-color: #fff;
}
</style>
